import { ChartVariant } from '@toggle/chart';
import { borderRadius, fontFamily, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

const colorRecord: Record<string, string> = {
  positive: 'var(--viz-bullish)',
  negative: 'var(--viz-bearish)',
  neutral: 'var(--viz-neutral)',
  info: 'var(--viz-info)',
  warning: 'var(--viz-warning)',
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--background-soft);
  ${borderRadius.r1};
  margin-left: 8px;
`;

export const Item = styled.div`
  display: flex;
  padding: 2px 4px;
  align-items: center;
  gap: 8px;
`;

export const Dot = styled.div<{ $color: ChartVariant }>`
  width: 8px;
  height: 8px;
  background-color: ${props => colorRecord[props.$color]};
  ${borderRadius.rFull};
`;

export const Label = styled.p`
  ${typographyV2.bodySm};
`;

export const Value = styled.span<{ $color: string }>`
  font-family: ${fontFamily.robotoMono};
  ${typographyV2.bodySm};
  color: ${props => colorRecord[props.$color]};
`;

export const PositiveLine = styled.span`
  width: 12px;
  height: 2px;
  ${borderRadius.r05};
  background-color: var(--viz-bullish);
`;

export const NegativeIndicator = styled.div`
  display: flex;
  gap: 1px;
`;

export const NegativeLine = styled.span`
  width: 4px;
  border: none;
  ${borderRadius.r05};
  border-top: 2px solid var(--viz-bearish);
`;
